export const EXCLUDED_COMMUNITY_NONE_VALUE = 'None';

export default {
  EXCLUDED_COMMUNITY_NONE_VALUE,
};
